<template>
    <div>
        <div style="margin-bottom: 5px;">
            <el-input v-model="keyword" placeholder="请输入名称/标识" suffix-icon="el-icon-search" style="width: 200px;"
                      @keyup.enter.native="loadPost"></el-input>
            <el-select v-model="qFilter" placeholder="品质筛选" style="margin-left: 5px; width: 130px;">
                <el-option v-for="item in qualityOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select>
            <el-button type="primary" style="margin-left: 5px;" @click="loadPost">查询</el-button>
            <el-button type="success" @click="resetParam">重置</el-button>
            <el-button type="primary" style="margin-left: 5px;" @click="add">新增宝藏</el-button>
            <el-button type="warning" style="margin-left: 5px;" @click="openTypeManage">类型管理</el-button>
            <el-select v-model="poolFilter" placeholder="奖池筛选（默认全部）" style="margin-left: 5px; width: 170px;" @change="handlePoolChange">
                <el-option label="全部奖池" value=""></el-option>
                <el-option v-for="p in poolOptions" :key="p.poolKey" :label="p.name" :value="p.poolKey"></el-option>
            </el-select>
            <el-button type="danger" style="margin-left: 5px;" @click="openPoolManage">奖池管理</el-button>
        </div>
        <el-table :data="tableData"
                  :header-cell-style="{ background: '#f2f5fc', color: '#555555' }"
                  border>
            <el-table-column prop="id" label="ID" width="50"></el-table-column>
            <el-table-column prop="itemId" label="标识(自动)" width="110"></el-table-column>
            <el-table-column label="品质" width="90">
                <template slot-scope="scope">
                    <el-tag :color="qualityColor(scope.row.q)" style="color: #fff; border: none;" size="mini"
                            disable-transitions>{{qualityName(scope.row.q)}}</el-tag>
                </template>
            </el-table-column>
            <el-table-column prop="name" label="名称" width="130"></el-table-column>
            <el-table-column prop="type" label="类型" width="90"></el-table-column>
            <el-table-column prop="amount" label="数量" width="70">
                <template slot-scope="scope">
                    <span v-if="scope.row.type === '碎片'">{{scope.row.amount || '-'}}</span>
                    <span v-else>-</span>
                </template>
            </el-table-column>
            <el-table-column label="出售价(星裙币)" width="120">
                <template slot-scope="scope">
                    <span v-if="scope.row.type === '碎片'" style="color: #ccc;">-</span>
                    <template v-else>
                        <span v-if="scope.row.price != null">{{scope.row.price}}</span>
                        <span v-else style="color: #aaa;">按品质{{qualityDefaultPrice(scope.row.q)}}</span>
                    </template>
                </template>
            </el-table-column>
            <el-table-column label="兑换碎片" width="110">
                <template slot-scope="scope">
                    <span v-if="scope.row.type === '碎片'" style="color: #ccc;">-</span>
                    <template v-else>
                        <span v-if="scope.row.fragCost != null">{{scope.row.fragCost}}</span>
                        <span v-else style="color: #aaa;">按品质{{qualityDefaultFrag(scope.row.q)}}</span>
                    </template>
                </template>
            </el-table-column>
            <el-table-column label="图片" width="80">
                <template slot-scope="scope">
                    <el-image v-if="imgUrl(scope.row.img)" :src="imgUrl(scope.row.img)" fit="cover"
                              style="width: 46px; height: 46px; border-radius: 4px;"
                              :preview-src-list="[imgUrl(scope.row.img)]" preview-teleported>
                        <div slot="error" style="width: 46px; height: 46px; display: flex; align-items: center; justify-content: center; color: #ccc; font-size: 12px;">无图</div>
                    </el-image>
                    <span v-else style="color: #ccc; font-size: 12px;">无图</span>
                </template>
            </el-table-column>
            <el-table-column prop="remark" label="描述" min-width="180" show-overflow-tooltip></el-table-column>
            <el-table-column label="奖池" width="110">
                <template slot-scope="scope">
                    <el-tag size="mini" disable-transitions>{{poolName(scope.row.poolKey)}}</el-tag>
                </template>
            </el-table-column>
            <el-table-column prop="sortOrder" label="排序" width="60"></el-table-column>
            <el-table-column label="启用" width="70">
                <template slot-scope="scope">
                    <el-switch v-model="scope.row.isShow" active-value="Y" inactive-value="N"
                               @change="showChange(scope.row)"></el-switch>
                </template>
            </el-table-column>
            <el-table-column prop="operate" label="操作" width="150">
                <template slot-scope="scope">
                    <el-button size="small" type="success" @click="mod(scope.row)">编辑</el-button>
                    <el-popconfirm title="确定删除吗？删除后奖池将不再出现该道具。" @confirm="del(scope.row.id)" style="margin-left: 5px;">
                        <el-button slot="reference" size="small" type="danger">删除</el-button>
                    </el-popconfirm>
                </template>
            </el-table-column>
        </el-table>

        <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="pageNum"
                :page-sizes="[5, 10, 20, 30]"
                :page-size="pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="total">
        </el-pagination>

        <!-- 新增/编辑宝藏 -->
        <el-dialog :title="form.id ? '编辑宝藏' : '新增宝藏'" :visible.sync="centerDialogVisible" width="45%" center>
            <el-form ref="form" :rules="rules" :model="form" label-width="90px">
                <el-form-item label="所属奖池" prop="poolKey">
                    <el-col :span="20">
                        <el-select v-model="form.poolKey" placeholder="选择所属奖池" style="width: 100%;">
                            <el-option v-for="p in poolOptions" :key="p.poolKey" :label="p.name" :value="p.poolKey"></el-option>
                        </el-select>
                        <div style="color: #999; font-size: 12px; line-height: 1.6; margin-top: 4px;">新增道具将加入所选奖池，前台抽奖、碎片商城、背包按奖池区分</div>
                    </el-col>
                </el-form-item>
                <el-form-item label="品质" prop="q">
                    <el-col :span="20">
                        <el-select v-model="form.q" placeholder="请选择品质" style="width: 100%;">
                            <el-option v-for="item in qualityOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
                        </el-select>
                    </el-col>
                </el-form-item>
                <el-form-item label="名称" prop="name">
                    <el-col :span="20"><el-input v-model="form.name"></el-input></el-col>
                </el-form-item>
                <el-form-item label="类型" prop="type">
                    <el-col :span="20">
                        <el-select v-model="form.type" filterable allow-create default-first-option placeholder="选择或输入类型" style="width: 100%;">
                            <el-option v-for="t in typeOptions" :key="t" :label="t" :value="t"></el-option>
                        </el-select>
                    </el-col>
                    <div style="color: #999; font-size: 12px; line-height: 1.6; margin-top: 4px;">
                        标识按类型自动生成：碎片→u_frag数量 / 其他类型（含货币）→auto+时间戳
                    </div>
                </el-form-item>
                <el-form-item v-if="form.type === '碎片'" label="数量" prop="amount">
                    <el-col :span="20">
                        <el-input-number v-model="form.amount" :min="1" :max="999999" controls-position="right"
                                         style="width: 160px;"></el-input-number>
                        <span style="margin-left: 8px; color: #999; font-size: 12px;">碎片礼包，抽到进入背包并累加碎片余额，在背包查看碎片数量</span>
                    </el-col>
                </el-form-item>
                <el-form-item v-if="form.type !== '碎片'" label="出售价">
                    <el-col :span="20">
                        <el-input-number v-model="form.price" :min="0" :max="99999999" controls-position="right"
                                         style="width: 160px;"></el-input-number>
                        <span style="margin-left: 8px; color: #999; font-size: 12px;">出售该道具获得的星裙币，留空按品质默认（{{qualityDefaultPrice(form.q)}}）</span>
                    </el-col>
                </el-form-item>
                <el-form-item v-if="form.type !== '碎片'" label="兑换碎片">
                    <el-col :span="20">
                        <el-input-number v-model="form.fragCost" :min="0" :max="99999999" controls-position="right"
                                         style="width: 160px;"></el-input-number>
                        <span style="margin-left: 8px; color: #999; font-size: 12px;">碎片商城兑换该道具所需碎片，留空按品质默认（{{qualityDefaultFrag(form.q)}}）</span>
                    </el-col>
                </el-form-item>
                <el-form-item label="图片">
                    <el-col :span="20">
                        <el-input v-model="form.img" placeholder="图片文件名（如 r1_jixingzhanjia.jpg）或完整图片URL"></el-input>
                        <div style="margin-top: 6px;">
                            <el-image v-if="imgUrl(form.img)" :src="imgUrl(form.img)" fit="cover"
                                      style="width: 60px; height: 60px; border-radius: 4px;"
                                      :preview-src-list="[imgUrl(form.img)]" preview-teleported>
                                <div slot="error" style="width: 60px; height: 60px; display: flex; align-items: center; justify-content: center; color: #ccc; font-size: 12px;">无图</div>
                            </el-image>
                            <span v-else style="color: #ccc; font-size: 12px;">暂无图片</span>
                        </div>
                    </el-col>
                </el-form-item>
                <el-form-item label="描述">
                    <el-col :span="20"><el-input v-model="form.remark" type="textarea" :rows="2"></el-input></el-col>
                </el-form-item>
                <el-form-item label="排序">
                    <el-col :span="20">
                        <el-input-number v-model="form.sortOrder" :min="0" :max="9999" controls-position="right" style="width: 160px;"></el-input-number>
                        <span style="margin-left: 8px; color: #999; font-size: 12px;">同品质内数字小者排在前面</span>
                    </el-col>
                </el-form-item>
                <el-form-item label="启用">
                    <el-col :span="20">
                        <el-switch v-model="form.isShow" active-value="Y" inactive-value="N"></el-switch>
                        <span style="margin-left: 8px; color: #999; font-size: 12px;">关闭后该道具不再出现在抽奖奖池</span>
                    </el-col>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="centerDialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="save">确 定</el-button>
            </span>
        </el-dialog>
        <!-- 类型管理 -->
        <el-dialog title="宝藏类型管理" :visible.sync="typeManageVisible" width="45%" center>
            <div style="margin-bottom: 10px; display: flex; align-items: center; flex-wrap: wrap;">
                <el-input v-model="typeForm.name" placeholder="新类型名称（如 宠物）" style="width: 180px;"></el-input>
                <el-input-number v-model="typeForm.sortOrder" :min="0" :max="9999" controls-position="right"
                                 style="width: 140px; margin-left: 5px;" placeholder="排序"></el-input-number>
                <el-button type="primary" style="margin-left: 5px;" @click="typeSave">添加类型</el-button>
                <span style="margin-left: 10px; color: #999; font-size: 12px;">
                    碎片为特殊类型（背包展示依赖），锁定不可删除或改名；货币及其余类型可自由添加、改名、删除
                </span>
            </div>
            <el-table :data="typeList"
                      height="320"
                      :header-cell-style="{ background: '#f2f5fc', color: '#555555' }"
                      border>
                <el-table-column prop="id" label="ID" width="60"></el-table-column>
                <el-table-column label="类型名称" min-width="150">
                    <template slot-scope="scope">
                        <el-input v-if="editingTypeId === scope.row.id" v-model="editingTypeName" size="small"
                                  style="width: 150px;"></el-input>
                        <span v-else>{{scope.row.name}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="特殊类型" width="90">
                    <template slot-scope="scope">
                        <el-tag v-if="scope.row.isSpecial === 'Y'" type="danger" size="mini" disable-transitions>特殊(锁定)</el-tag>
                        <span v-else style="color: #999;">-</span>
                    </template>
                </el-table-column>
                <el-table-column prop="sortOrder" label="排序" width="70"></el-table-column>
                <el-table-column label="操作" width="170">
                    <template slot-scope="scope">
                        <template v-if="scope.row.isSpecial !== 'Y'">
                            <el-button v-if="editingTypeId !== scope.row.id" size="small" type="success"
                                       @click="typeEditStart(scope.row)">改名</el-button>
                            <template v-else>
                                <el-button size="small" type="primary" @click="typeEditSave(scope.row)">保存</el-button>
                                <el-button size="small" @click="typeEditCancel">取消</el-button>
                            </template>
                            <el-popconfirm title="确定删除该类型吗？" @confirm="typeDel(scope.row.id)" style="margin-left: 5px;">
                                <el-button slot="reference" size="small" type="danger">删除</el-button>
                            </el-popconfirm>
                        </template>
                        <span v-else style="color: #ccc; font-size: 12px;">不可操作</span>
                    </template>
                </el-table-column>
            </el-table>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="typeManageVisible = false">关 闭</el-button>
            </span>
        </el-dialog>

        <!-- 奖池管理 -->
        <el-dialog title="奖池管理（洛丽寻宝右侧奖池切换栏由此增删改）" :visible.sync="poolManageVisible" width="62%" center>
            <div style="margin-bottom: 10px; display: flex; align-items: center; flex-wrap: wrap;">
                <el-button type="primary" @click="openPoolAdd">新增奖池</el-button>
                <span style="margin-left: 10px; color: #999; font-size: 12px;">
                    奖池标识唯一（小写字母开头，可含数字/下划线）；主题色用于抽奖按钮与页面氛围；图片目录对应组件内图片文件夹
                </span>
            </div>
            <el-table :data="poolList"
                      height="340"
                      :header-cell-style="{ background: '#f2f5fc', color: '#555555' }"
                      border>
                <el-table-column prop="id" label="ID" width="55"></el-table-column>
                <el-table-column prop="poolKey" label="奖池标识" width="120"></el-table-column>
                <el-table-column label="名称" min-width="110">
                    <template slot-scope="scope">{{scope.row.name}}</template>
                </el-table-column>
                <el-table-column label="图标" width="70">
                    <template slot-scope="scope"><span style="font-size: 18px;">{{scope.row.icon || '🎁'}}</span></template>
                </el-table-column>
                <el-table-column label="按钮色" width="80">
                    <template slot-scope="scope">
                        <span :style="{ display: 'inline-block', width: '18px', height: '18px', borderRadius: '4px', background: scope.row.btnColor || scope.row.themeColor || '#f0619c', verticalAlign: 'middle' }"></span>
                    </template>
                </el-table-column>
                <el-table-column label="背景色" width="80">
                    <template slot-scope="scope">
                        <span :style="{ display: 'inline-block', width: '18px', height: '18px', borderRadius: '4px', background: scope.row.bgColor || mixWhite(scope.row.themeColor || '#f0619c', 0.85), verticalAlign: 'middle' }"></span>
                    </template>
                </el-table-column>
                <el-table-column label="卡牌色" width="80">
                    <template slot-scope="scope">
                        <span :style="{ display: 'inline-block', width: '18px', height: '18px', borderRadius: '4px', background: scope.row.cardColor || scope.row.themeDeep || '#ff5fa8', verticalAlign: 'middle' }"></span>
                    </template>
                </el-table-column>
                <el-table-column prop="itemCount" label="道具数" width="70">
                    <template slot-scope="scope">{{scope.row.itemCount != null ? scope.row.itemCount : '-'}}</template>
                </el-table-column>
                <el-table-column label="启用" width="70">
                    <template slot-scope="scope">
                        <el-switch v-model="scope.row.isShow" active-value="Y" inactive-value="N"
                                   @change="poolShowChange(scope.row)"></el-switch>
                    </template>
                </el-table-column>
                <el-table-column prop="operate" label="操作" width="150">
                    <template slot-scope="scope">
                        <el-button size="small" type="success" @click="poolEdit(scope.row)">编辑</el-button>
                        <el-popconfirm title="确定删除该奖池吗？奖池下仍有道具时无法删除。" @confirm="poolDel(scope.row.id)" style="margin-left: 5px;">
                            <el-button slot="reference" size="small" type="danger">删除</el-button>
                        </el-popconfirm>
                    </template>
                </el-table-column>
            </el-table>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="poolManageVisible = false">关 闭</el-button>
            </span>
        </el-dialog>

        <!-- 新增/编辑奖池 -->
        <el-dialog :title="poolForm.id ? '编辑奖池' : '新增奖池'" :visible.sync="poolFormDialogVisible" width="58%" center>
            <el-form :model="poolForm" label-width="100px">
                <el-form-item label="奖池标识" required>
                    <el-col :span="20">
                        <el-input v-model="poolForm.poolKey" :disabled="!!poolForm.id"
                                  placeholder="小写字母开头，如 fairy_tales"></el-input>
                        <div style="color: #999; font-size: 12px; line-height: 1.6; margin-top: 4px;">创建后不可修改，道具归属依赖此标识</div>
                    </el-col>
                </el-form-item>
                <el-form-item label="奖池名称" required>
                    <el-col :span="20"><el-input v-model="poolForm.name" placeholder="如 星月童话"></el-input></el-col>
                </el-form-item>
                <el-form-item label="图标">
                    <el-col :span="20"><el-input v-model="poolForm.icon" placeholder="emoji，如 🌙"></el-input></el-col>
                </el-form-item>

                <!-- 主题预设：一键填充整套配色，之后仍可单独调整 内置 8 套预设搭配（粉樱之约、星月蓝梦、紫夜精灵、蜜桃奶昔、薄荷青柠、落日橙光、冰雪蓝调、星黛紫）-->
                <el-form-item label="主题预设">
                    <el-col :span="24">
                        <div class="preset-row">
                            <div v-for="preset in themePresets" :key="preset.name" class="preset-chip"
                                 :class="{ active: isPresetActive(preset) }" @click="applyPreset(preset)">
                                <span class="preset-swatch"
                                      :style="{ background: 'linear-gradient(135deg, ' + preset.btnColor + ', ' + preset.btnDeep + ')' }"></span>
                                <span class="preset-name">{{ preset.name }}</span>
                            </div>
                        </div>
                        <div style="color: #999; font-size: 12px; margin-top: 6px;">点击预设一键填充整套配色，也可在下方分组中单独调整</div>
                    </el-col>
                </el-form-item>

                <!-- 按钮颜色搭配 -->
                <el-form-item label="按钮配色">
                    <el-col :span="24">
                        <div class="color-group">
                            <div class="color-item">
                                <span class="color-label">按钮主色</span>
                                <el-color-picker v-model="poolForm.btnColor"></el-color-picker>
                                <span class="color-desc">渐变起点</span>
                            </div>
                            <div class="color-item">
                                <span class="color-label">按钮深色</span>
                                <el-color-picker v-model="poolForm.btnDeep"></el-color-picker>
                                <span class="color-desc">渐变端点</span>
                            </div>
                            <div class="btn-preview" :style="btnPreviewStyle">抽奖按钮</div>
                        </div>
                    </el-col>
                </el-form-item>

                <!-- 背景颜色搭配 -->
                <el-form-item label="背景配色">
                    <el-col :span="24">
                        <div class="color-group">
                            <div class="color-item">
                                <span class="color-label">背景主色</span>
                                <el-color-picker v-model="poolForm.bgColor"></el-color-picker>
                                <span class="color-desc">氛围主调</span>
                            </div>
                            <div class="color-item">
                                <span class="color-label">背景深色</span>
                                <el-color-picker v-model="poolForm.bgDeep"></el-color-picker>
                                <span class="color-desc">渐变端点</span>
                            </div>
                            <div class="bg-preview" :style="bgPreviewStyle">背景预览</div>
                        </div>
                    </el-col>
                </el-form-item>

                <!-- 文字高亮色 -->
                <el-form-item label="文字高亮">
                    <el-col :span="24">
                        <div class="color-group">
                            <div class="color-item">
                                <span class="color-label">高亮文字色</span>
                                <el-color-picker v-model="poolForm.textColor"></el-color-picker>
                                <span class="color-desc">标题/装饰文字</span>
                            </div>
                            <div class="text-preview" :style="{ color: poolForm.textColor }">奖池标题示例</div>
                        </div>
                    </el-col>
                </el-form-item>

                <!-- 卡牌配色 -->
                <el-form-item label="卡牌配色">
                    <el-col :span="24">
                        <div class="color-group">
                            <div class="color-item">
                                <span class="color-label">卡牌主色</span>
                                <el-color-picker v-model="poolForm.cardColor"></el-color-picker>
                                <span class="color-desc">抽奖卡背装饰/背景</span>
                            </div>
                            <div class="card-preview" :style="cardPreviewStyle">
                                <span class="card-preview-pattern"></span>
                                <span class="card-preview-text">星裙补给</span>
                            </div>
                        </div>
                    </el-col>
                </el-form-item>

                <el-form-item label="图片目录">
                    <el-col :span="20"><el-input v-model="poolForm.imgDir" placeholder="相对 LolitaTreasure 组件目录，如 fairy-tales"></el-input></el-col>
                </el-form-item>
                <el-form-item label="排序">
                    <el-col :span="20">
                        <el-input-number v-model="poolForm.sortOrder" :min="0" :max="9999" controls-position="right" style="width: 160px;"></el-input-number>
                        <span style="margin-left: 8px; color: #999; font-size: 12px;">数字小者排在右侧切换栏上方</span>
                    </el-col>
                </el-form-item>
                <el-form-item label="启用">
                    <el-col :span="20">
                        <el-switch v-model="poolForm.isShow" active-value="Y" inactive-value="N"></el-switch>
                        <span style="margin-left: 8px; color: #999; font-size: 12px;">停用后前台洛丽寻宝不再显示该奖池</span>
                    </el-col>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="poolFormDialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="poolFormSave">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    // 宝藏立绘统一从洛丽寻宝目录递归打包加载（webpack require.context）
    // 后台新增奖池后，只需在 LolitaTreasure 下新建对应目录并放入图片即可被识别，无需再改代码
    const treasureImages = {}
    ;(function () {
        const ctx = require.context('../LolitaTreasure', true, /\.(jpg|jpeg|png|gif)$/)
        ctx.keys().forEach(function (k) {
            const name = k.split('/').pop().replace(/\.[a-z0-9]+$/i, '').toLowerCase()
            if (!treasureImages[name]) treasureImages[name] = ctx(k)
        })
    })()

    // 品质配置（与洛丽寻宝游戏保持一致）
    const QUALITY_MAP = {
        red: {name: '传说', color: '#ff4d6d', price: 888, fragCost: 800},
        pink: {name: '史诗', color: '#ff7fb9', price: 88, fragCost: 150},
        blue: {name: '稀有', color: '#7fc9ff', price: 18, fragCost: 60},
        purple: {name: '精良', color: '#c39aff', price: 8, fragCost: 30},
        green: {name: '普通', color: '#7fdc9c', price: 2, fragCost: 15}
    }

    // 类型下拉兜底（接口不可用时使用；碎片为背包展示特殊类型，货币为普通类型）
    const DEFAULT_TYPES = ['套装', '枪械', '狙击枪', '冲锋枪', '步枪', '霰弹枪', '背包', '头盔', '降落伞', '载具', '飞行器', '鞋', '消耗品', '货币', '碎片']

    // 主题预设搭配：按钮主色/深色、背景主色/深色、文字高亮色 一键填充
    const THEME_PRESETS = [
        {name: '粉樱之约', btnColor: '#F0619C', btnDeep: '#E0539C', bgColor: '#FDE7F0', bgDeep: '#F7C9DC', textColor: '#E0539C', cardColor: '#FF5FA8'},
        {name: '星月蓝梦', btnColor: '#6F8BFF', btnDeep: '#4A5BD8', bgColor: '#E8EDFF', bgDeep: '#C9D4F7', textColor: '#4A5BD8', cardColor: '#5B7CFA'},
        {name: '紫夜精灵', btnColor: '#A78BFA', btnDeep: '#7C5CE0', bgColor: '#EFE9FF', bgDeep: '#D8CBF8', textColor: '#7C5CE0', cardColor: '#8B6CF5'},
        {name: '蜜桃奶昔', btnColor: '#FF9FB2', btnDeep: '#F76B8A', bgColor: '#FFF0F3', bgDeep: '#FFD3DC', textColor: '#F76B8A', cardColor: '#F76B8A'},
        {name: '薄荷青柠', btnColor: '#5ECDB5', btnDeep: '#2FA88C', bgColor: '#E4F8F2', bgDeep: '#C6EDE1', textColor: '#2FA88C', cardColor: '#2FA88C'},
        {name: '落日橙光', btnColor: '#FFA26B', btnDeep: '#F76B4A', bgColor: '#FFF0E6', bgDeep: '#FFD9C2', textColor: '#F76B4A', cardColor: '#F76B4A'},
        {name: '冰雪蓝调', btnColor: '#7FD0FF', btnDeep: '#3E9FE0', bgColor: '#EAF7FF', bgDeep: '#CDEBFB', textColor: '#3E9FE0', cardColor: '#3E9FE0'},
        {name: '星黛紫', btnColor: '#B48CFF', btnDeep: '#8B5CF6', bgColor: '#F3ECFF', bgDeep: '#E2D3FF', textColor: '#8B5CF6', cardColor: '#8B5CF6'}
    ]

    // 混白（生成与主题匹配的浅色背景），输入 #RRGGBB，ratio 0~1
    function mixWhite(hex, ratio) {
        if (!hex) return hex
        const m = /^#?([0-9a-fA-F]{6})$/.exec(String(hex).trim())
        if (!m) return hex
        const n = parseInt(m[1], 16)
        const r = Math.round(((n >> 16) & 255) + (255 - ((n >> 16) & 255)) * ratio)
        const g = Math.round(((n >> 8) & 255) + (255 - ((n >> 8) & 255)) * ratio)
        const b = Math.round((n & 255) + (255 - (n & 255)) * ratio)
        return '#' + [r, g, b].map(function (v) { return ('0' + v.toString(16)).slice(-2) }).join('')
    }

    export default {
        name: "Treasure-management",
        data() {
            return {
                user: JSON.parse(sessionStorage.getItem('CurUser') || '{}'),
                tableData: [],
                qualityOptions: [{value: '', label: '全部品质'}, {value: 'red', label: '传说'}, {value: 'pink', label: '史诗'}, {value: 'blue', label: '稀有'}, {value: 'purple', label: '精良'}, {value: 'green', label: '普通'}],
                typeOptions: DEFAULT_TYPES,
                keyword: '',
                qFilter: '',
                pageNum: 1,
                pageSize: 10,
                total: 0,
                centerDialogVisible: false,
                typeManageVisible: false,
                typeList: [],
                typeForm: {name: '', sortOrder: 0},
                editingTypeId: null,
                editingTypeName: '',
                poolFilter: '',
                poolOptions: [],
                poolManageVisible: false,
                poolList: [],
                themePresets: THEME_PRESETS,
                poolFormDialogVisible: false,
                poolForm: {
                    id: '', poolKey: '', name: '', icon: '',
                    themeColor: '#F0619C', themeDeep: '#E0539C',
                    btnColor: '#F0619C', btnDeep: '#E0539C',
                    bgColor: '#FDE7F0', bgDeep: '#F7C9DC',
                    textColor: '#E0539C',
                    cardColor: '#FF5FA8',
                    imgDir: '', sortOrder: 0, isShow: 'Y'
                },
                form: {
                    id: '',
                    q: '',
                    name: '',
                    type: '',
                    amount: 0,
                    price: null,
                    fragCost: null,
                    img: '',
                    remark: '',
                    sortOrder: 0,
                    isShow: 'Y',
                    poolKey: ''
                },
                rules: {
                    q: [{required: true, message: '请选择品质', trigger: 'change'}],
                    name: [{required: true, message: '请输入道具名称', trigger: 'blur'}],
                    type: [{required: true, message: '请选择道具类型', trigger: 'change'}],
                    amount: [{
                        validator: (rule, value, callback) => {
                            if (this.form.type === '碎片') {
                                if (value == null || value <= 0) {
                                    callback(new Error('类型为碎片时必须填写数量（大于 0）'))
                                } else {
                                    callback()
                                }
                            } else {
                                callback()
                            }
                        },
                        trigger: 'change'
                    }]
                }
            }
        },
        computed: {
            // 按钮配色实时预览（渐变）
            btnPreviewStyle() {
                return {
                    background: 'linear-gradient(135deg, ' + (this.poolForm.btnColor || '#F0619C') + ', ' + (this.poolForm.btnDeep || '#E0539C') + ')'
                }
            },
            // 背景配色实时预览（渐变）
            bgPreviewStyle() {
                return {
                    background: 'linear-gradient(180deg, ' + (this.poolForm.bgColor || '#FDE7F0') + ', ' + (this.poolForm.bgDeep || '#F7C9DC') + ')'
                }
            },
            // 卡牌背面实时预览（与前台抽奖卡背一致的浅色渐变 + 装饰圆点）
            cardPreviewStyle() {
                const c = this.poolForm.cardColor || '#FF5FA8'
                const m = /^#?([0-9a-fA-F]{6})$/.exec(String(c).trim())
                let rgb = '255, 95, 168'
                if (m) {
                    const n = parseInt(m[1], 16)
                    rgb = ((n >> 16) & 255) + ', ' + ((n >> 8) & 255) + ', ' + (n & 255)
                }
                return {
                    background: 'radial-gradient(circle at 50% 26%, rgba(255,255,255,0.85) 0 13px, transparent 14px), radial-gradient(circle at 16px 16px, rgba(' + rgb + ',0.22) 2px, transparent 2.7px), linear-gradient(160deg, ' + mixWhite(c, 0.93) + ', ' + mixWhite(c, 0.82) + ' 55%, ' + mixWhite(c, 0.68) + ')',
                    border: '2px solid ' + mixWhite(c, 0.45)
                }
            }
        },
        watch: {
            // 选择/切换品质时，若价格或兑换碎片尚未填写则自动填入该品质默认值（已填写的不覆盖）
            'form.q': function (nv) {
                if (!nv) return
                const def = QUALITY_MAP[nv]
                if (!def) return
                if (this.form.price == null || this.form.price === '') {
                    this.form.price = def.price
                }
                if (this.form.fragCost == null || this.form.fragCost === '') {
                    this.form.fragCost = def.fragCost
                }
            }
        },
        methods: {
            qualityName(q) {
                return (QUALITY_MAP[q] || {}).name || q || '未知'
            },
            qualityColor(q) {
                return (QUALITY_MAP[q] || {}).color || '#909399'
            },
            qualityDefaultPrice(q) {
                return (QUALITY_MAP[q] || {}).price != null ? (QUALITY_MAP[q] || {}).price : '-'
            },
            qualityDefaultFrag(q) {
                return (QUALITY_MAP[q] || {}).fragCost != null ? (QUALITY_MAP[q] || {}).fragCost : '-'
            },
            imgUrl(file) {
                if (!file) return ''
                if (/^https?:\/\//i.test(file)) return file
                const key = String(file).replace(/\.[a-z0-9]+$/i, '').toLowerCase()
                return treasureImages[key] || ''
            },
            resetForm() {
                this.$refs.form && this.$refs.form.resetFields();
            },
            // 混白（生成与主题匹配的浅色背景），模板中用于背景色列展示
            mixWhite(hex, ratio) {
                if (!hex) return hex
                const m = /^#?([0-9a-fA-F]{6})$/.exec(String(hex).trim())
                if (!m) return hex
                const n = parseInt(m[1], 16)
                const r = Math.round(((n >> 16) & 255) + (255 - ((n >> 16) & 255)) * ratio)
                const g = Math.round(((n >> 8) & 255) + (255 - ((n >> 8) & 255)) * ratio)
                const b = Math.round((n & 255) + (255 - (n & 255)) * ratio)
                return '#' + [r, g, b].map(function (v) { return ('0' + v.toString(16)).slice(-2) }).join('')
            },
            // 加载类型列表（类型下拉数据源）
            loadTypes() {
                this.$axios.get(this.$httpUrl + '/treasureType/list')
                    .then(res => res.data)
                    .then(res => {
                        if (res.code == 200 && Array.isArray(res.data) && res.data.length > 0) {
                            this.typeOptions = res.data.map(t => t.name)
                            this.typeList = res.data
                        }
                    })
            },
            // 打开类型管理弹窗并刷新列表
            openTypeManage() {
                this.typeForm = {name: '', sortOrder: 0}
                this.editingTypeId = null
                this.editingTypeName = ''
                this.typeManageVisible = true
                this.loadTypes()
            },
            // 添加类型
            typeSave() {
                const name = (this.typeForm.name || '').trim()
                if (!name) {
                    this.$message({message: '请输入类型名称', type: 'warning'});
                    return
                }
                this.$axios.post(this.$httpUrl + '/treasureType/save', {
                    name: name,
                    sortOrder: this.typeForm.sortOrder || 0
                }, {
                    params: {
                        operatorNo: this.user.no,
                        operatorName: this.user.name,
                        operatorRole: this.user.roleId
                    }
                }).then(res => res.data).then(res => {
                    if (res.code == 200) {
                        this.$message({message: '添加成功', type: 'success'});
                        this.typeForm = {name: '', sortOrder: 0}
                        this.loadTypes()
                    } else {
                        this.$message({message: res.msg || '添加失败', type: 'error'});
                    }
                })
            },
            typeEditStart(row) {
                this.editingTypeId = row.id
                this.editingTypeName = row.name
            },
            typeEditCancel() {
                this.editingTypeId = null
                this.editingTypeName = ''
            },
            // 保存改名（同步更新该类型下的宝藏道具）
            typeEditSave(row) {
                const name = (this.editingTypeName || '').trim()
                if (!name) {
                    this.$message({message: '类型名称不能为空', type: 'warning'});
                    return
                }
                if (name === row.name) {
                    this.typeEditCancel()
                    return
                }
                this.$axios.post(this.$httpUrl + '/treasureType/update', {
                    id: row.id,
                    name: name
                }, {
                    params: {
                        operatorNo: this.user.no,
                        operatorName: this.user.name,
                        operatorRole: this.user.roleId
                    }
                }).then(res => res.data).then(res => {
                    if (res.code == 200) {
                        this.$message({message: '改名成功，已同步更新该类型下的宝藏道具', type: 'success'});
                        this.typeEditCancel()
                        this.loadTypes()
                    } else {
                        this.$message({message: res.msg || '修改失败', type: 'error'});
                    }
                })
            },
            // 删除类型（特殊类型/有道具占用的类型由后端拦截）
            typeDel(id) {
                this.$axios.get(this.$httpUrl + '/treasureType/del', {
                    params: {
                        id: id,
                        operatorNo: this.user.no,
                        operatorName: this.user.name,
                        operatorRole: this.user.roleId
                    }
                }).then(res => res.data).then(res => {
                    if (res.code == 200) {
                        this.$message({message: '删除成功', type: 'success'});
                        this.loadTypes()
                    } else {
                        this.$message({message: res.msg || '删除失败', type: 'error'});
                    }
                })
            },
            showChange(row) {
                this.$axios.post(this.$httpUrl + '/treasure/admin/update', {
                    id: row.id,
                    itemId: row.itemId,
                    q: row.q,
                    name: row.name,
                    type: row.type,
                    amount: row.amount,
                    price: row.price,
                    fragCost: row.fragCost,
                    img: row.img,
                    remark: row.remark,
                    sortOrder: row.sortOrder,
                    isShow: row.isShow,
                    operatorNo: this.user.no,
                    operatorName: this.user.name,
                    operatorRole: this.user.roleId
                }).then(res => res.data).then(res => {
                    if (res.code == 200) {
                        this.$message({message: row.isShow === 'Y' ? '已启用该道具' : '已停用该道具', type: 'success'});
                        this.loadPost()
                    } else {
                        this.$message({message: res.msg || '操作失败！', type: 'error'});
                        this.loadPost()
                    }
                })
            },
            del(id) {
                this.$axios.get(this.$httpUrl + '/treasure/admin/del', {
                    params: {
                        id: id,
                        operatorNo: this.user.no,
                        operatorName: this.user.name,
                        operatorRole: this.user.roleId
                    }
                }).then(res => res.data).then(res => {
                    if (res.code == 200) {
                        this.$message({message: '操作成功！', type: 'success'});
                        this.loadPost()
                    } else {
                        this.$message({message: res.msg || '操作失败！', type: 'error'});
                    }
                })
            },
            add() {
                this.centerDialogVisible = true
                this.$nextTick(() => {
                    this.resetForm()
                    this.form = {id: '', q: '', name: '', type: '', amount: 0, price: null, fragCost: null, img: '', remark: '', sortOrder: 0, isShow: 'Y', poolKey: this.poolFilter || ((this.poolOptions[0] && this.poolOptions[0].poolKey) || 'star_skirt')}
                })
            },
            mod(row) {
                this.centerDialogVisible = true
                this.$nextTick(() => {
                    this.form.id = row.id
                    this.form.q = row.q
                    this.form.name = row.name
                    this.form.type = row.type || ''
                    this.form.amount = row.amount == null ? 0 : row.amount
                    this.form.price = row.price == null ? null : row.price
                    this.form.fragCost = row.fragCost == null ? null : row.fragCost
                    this.form.img = row.img || ''
                    this.form.remark = row.remark || ''
                    this.form.sortOrder = row.sortOrder == null ? 0 : row.sortOrder
                    this.form.isShow = row.isShow || 'Y'
                    this.form.poolKey = row.poolKey || 'star_skirt'
                })
            },
            save() {
                this.$refs.form.validate((valid) => {
                    if (valid) {
                        let body = Object.assign({}, this.form)
                        let url = this.form.id ? '/treasure/admin/update' : '/treasure/admin/save'
                        this.$axios.post(this.$httpUrl + url, body, {
                            params: {
                                operatorNo: this.user.no,
                                operatorName: this.user.name,
                                operatorRole: this.user.roleId
                            }
                        }).then(res => res.data).then(res => {
                            if (res.code == 200) {
                                this.$message({message: '操作成功！', type: 'success'});
                                this.centerDialogVisible = false
                                this.loadPost()
                                // 若使用了类型列表之外的新类型，自动登记到类型库（可在类型管理中改名/删除）
                                if (this.form.type && this.typeOptions.indexOf(this.form.type) < 0) {
                                    this.$axios.post(this.$httpUrl + '/treasureType/save', {
                                        name: this.form.type,
                                        sortOrder: 0
                                    }, {
                                        params: {
                                            operatorNo: this.user.no,
                                            operatorName: this.user.name,
                                            operatorRole: this.user.roleId
                                        }
                                    }).then(() => this.loadTypes())
                                }
                            } else {
                                this.$message({message: res.msg || '操作失败！', type: 'error'});
                            }
                        })
                    } else {
                        return false;
                    }
                });
            },
            resetParam() {
                this.keyword = ''
                this.qFilter = ''
            },
            handleSizeChange(val) {
                this.pageNum = 1
                this.pageSize = val
                this.loadPost()
            },
            handleCurrentChange(val) {
                this.pageNum = val
                this.loadPost()
            },
            loadPost() {
                this.$axios.post(this.$httpUrl + '/treasure/admin/listPage', {
                    pageSize: this.pageSize,
                    pageNum: this.pageNum,
                    param: {keyword: this.keyword, q: this.qFilter, poolKey: this.poolFilter}
                }).then(res => res.data).then(res => {
                    if (res.code == 200) {
                        this.tableData = res.data
                        this.total = res.total
                    } else {
                        alert('获取数据失败')
                    }
                })
            },
            poolName(poolKey) {
                if (!poolKey) return '星裙补给'
                const p = this.poolOptions.find(x => x.poolKey === poolKey)
                return p ? p.name : poolKey
            },
            // 加载奖池下拉选项
            loadPools() {
                this.$axios.get(this.$httpUrl + '/treasurePool/list')
                    .then(res => res.data)
                    .then(res => {
                        if (res.code == 200 && Array.isArray(res.data)) {
                            this.poolOptions = res.data
                        }
                    })
            },
            // 奖池筛选变化时刷新道具列表
            handlePoolChange() {
                this.pageNum = 1
                this.loadPost()
            },
            // 打开奖池管理弹窗并刷新列表
            openPoolManage() {
                this.poolManageVisible = true
                this.loadPoolList()
            },
            // 奖池列表（含道具数）
            loadPoolList() {
                this.$axios.post(this.$httpUrl + '/treasurePool/admin/listPage', {
                    pageSize: 50,
                    pageNum: 1,
                    param: {keyword: ''}
                }).then(res => res.data).then(res => {
                    if (res.code == 200) {
                        this.poolList = res.data
                        this.loadPools()
                    } else {
                        this.$message({message: res.msg || '获取奖池失败', type: 'error'})
                    }
                })
            },
            // 新增奖池（弹窗）
            openPoolAdd() {
                this.poolForm = {
                    id: '', poolKey: '', name: '', icon: '',
                    themeColor: '#F0619C', themeDeep: '#E0539C',
                    btnColor: '#F0619C', btnDeep: '#E0539C',
                    bgColor: '#FDE7F0', bgDeep: '#F7C9DC',
                    textColor: '#E0539C',
                    cardColor: '#FF5FA8',
                    imgDir: '', sortOrder: 0, isShow: 'Y'
                }
                this.poolFormDialogVisible = true
            },
            // 一键填充预设配色（同时同步基础主题色，保持旧字段兼容）
            applyPreset(preset) {
                this.poolForm.btnColor = preset.btnColor
                this.poolForm.btnDeep = preset.btnDeep
                this.poolForm.bgColor = preset.bgColor
                this.poolForm.bgDeep = preset.bgDeep
                this.poolForm.textColor = preset.textColor
                this.poolForm.cardColor = preset.cardColor
                this.poolForm.themeColor = preset.btnColor
                this.poolForm.themeDeep = preset.btnDeep
            },
            // 判断当前表单配色是否与预设完全一致（用于高亮当前选中预设）
            isPresetActive(preset) {
                return this.poolForm.btnColor === preset.btnColor &&
                    this.poolForm.btnDeep === preset.btnDeep &&
                    this.poolForm.bgColor === preset.bgColor &&
                    this.poolForm.bgDeep === preset.bgDeep &&
                    this.poolForm.textColor === preset.textColor &&
                    this.poolForm.cardColor === preset.cardColor
            },
            // 编辑奖池
            poolEdit(row) {
                const themeColor = row.themeColor || '#F0619C'
                const themeDeep = row.themeDeep || '#E0539C'
                this.poolForm = {
                    id: row.id,
                    poolKey: row.poolKey,
                    name: row.name,
                    icon: row.icon || '',
                    themeColor: themeColor,
                    themeDeep: themeDeep,
                    // 新配色字段：旧数据缺失时自动回退/按主题生成匹配的浅色
                    btnColor: row.btnColor || themeColor,
                    btnDeep: row.btnDeep || themeDeep,
                    bgColor: row.bgColor || mixWhite(themeColor, 0.85),
                    bgDeep: row.bgDeep || mixWhite(themeDeep, 0.8),
                    textColor: row.textColor || themeDeep,
                    cardColor: row.cardColor || themeDeep,
                    imgDir: row.imgDir || '',
                    sortOrder: row.sortOrder == null ? 0 : row.sortOrder,
                    isShow: row.isShow || 'Y'
                }
                this.poolFormDialogVisible = true
            },
            // 保存奖池（新增/编辑）
            poolFormSave() {
                const key = (this.poolForm.poolKey || '').trim()
                const name = (this.poolForm.name || '').trim()
                if (!key) {
                    this.$message({message: '奖池标识不能为空', type: 'warning'})
                    return
                }
                if (!/^[a-z][a-z0-9_]*$/.test(key)) {
                    this.$message({message: '奖池标识需小写字母开头，可含数字和下划线', type: 'warning'})
                    return
                }
                if (!name) {
                    this.$message({message: '奖池名称不能为空', type: 'warning'})
                    return
                }
                // 独立配色：新字段留空时回退基础主题色；基础主题色同步为按钮主色/深色（兼容旧逻辑）
                const btnColor = this.poolForm.btnColor || this.poolForm.themeColor || '#F0619C'
                const btnDeep = this.poolForm.btnDeep || this.poolForm.themeDeep || '#E0539C'
                const body = Object.assign({}, this.poolForm, {
                    poolKey: key,
                    name: name,
                    themeColor: btnColor,
                    themeDeep: btnDeep,
                    btnColor: btnColor,
                    btnDeep: btnDeep,
                    bgColor: this.poolForm.bgColor || btnColor,
                    bgDeep: this.poolForm.bgDeep || btnDeep,
                    textColor: this.poolForm.textColor || btnDeep,
                    cardColor: this.poolForm.cardColor || btnDeep
                })
                const url = this.poolForm.id ? '/treasurePool/admin/update' : '/treasurePool/admin/save'
                this.$axios.post(this.$httpUrl + url, body, {
                    params: {
                        operatorNo: this.user.no,
                        operatorName: this.user.name,
                        operatorRole: this.user.roleId
                    }
                }).then(res => res.data).then(res => {
                    if (res.code == 200) {
                        this.$message({message: '操作成功', type: 'success'})
                        this.poolFormDialogVisible = false
                        this.loadPoolList()
                        this.loadPools()
                    } else {
                        this.$message({message: res.msg || '操作失败', type: 'error'})
                    }
                })
            },
            // 启用/停用奖池
            poolShowChange(row) {
                this.$axios.post(this.$httpUrl + '/treasurePool/admin/update', {
                    id: row.id,
                    poolKey: row.poolKey,
                    name: row.name,
                    icon: row.icon,
                    themeColor: row.btnColor || row.themeColor || '#F0619C',
                    themeDeep: row.btnDeep || row.themeDeep || '#E0539C',
                    btnColor: row.btnColor || row.themeColor || '#F0619C',
                    btnDeep: row.btnDeep || row.themeDeep || '#E0539C',
                    bgColor: row.bgColor || mixWhite(row.themeColor || '#F0619C', 0.85),
                    bgDeep: row.bgDeep || mixWhite(row.themeDeep || '#E0539C', 0.8),
                    textColor: row.textColor || row.themeDeep || '#E0539C',
                    cardColor: row.cardColor || row.themeDeep || '#E0539C',
                    imgDir: row.imgDir,
                    sortOrder: row.sortOrder,
                    isShow: row.isShow
                }, {
                    params: {
                        operatorNo: this.user.no,
                        operatorName: this.user.name,
                        operatorRole: this.user.roleId
                    }
                }).then(res => res.data).then(res => {
                    if (res.code == 200) {
                        this.$message({message: row.isShow === 'Y' ? '已启用该奖池' : '已停用该奖池', type: 'success'})
                        this.loadPoolList()
                        this.loadPools()
                    } else {
                        this.$message({message: res.msg || '操作失败', type: 'error'})
                        this.loadPoolList()
                    }
                })
            },
            // 删除奖池（奖池下仍有道具时后端拦截）
            poolDel(id) {
                this.$axios.get(this.$httpUrl + '/treasurePool/admin/del', {
                    params: {
                        id: id,
                        operatorNo: this.user.no,
                        operatorName: this.user.name,
                        operatorRole: this.user.roleId
                    }
                }).then(res => res.data).then(res => {
                    if (res.code == 200) {
                        this.$message({message: '删除成功', type: 'success'})
                        this.loadPoolList()
                        this.loadPools()
                    } else {
                        this.$message({message: res.msg || '删除失败', type: 'error'})
                    }
                })
            }
        },
        beforeMount() {
            this.loadPost()
            this.loadTypes()
            this.loadPools()
        }
    }
</script>

<style scoped>
    /* 主题预设色板 */
    .preset-row {
        display: flex;
        flex-wrap: wrap;
        gap: 8px;
    }
    .preset-chip {
        display: inline-flex;
        align-items: center;
        gap: 6px;
        padding: 4px 10px;
        border: 1px solid #e4e7ed;
        border-radius: 14px;
        cursor: pointer;
        font-size: 12px;
        color: #606266;
        transition: all .2s;
        user-select: none;
    }
    .preset-chip:hover {
        border-color: #f0619c;
        color: #f0619c;
    }
    .preset-chip.active {
        border-color: #f0619c;
        background: rgba(240, 97, 156, .08);
        color: #f0619c;
        font-weight: 600;
    }
    .preset-swatch {
        width: 16px;
        height: 16px;
        border-radius: 50%;
        flex-shrink: 0;
    }

    /* 分组配色行 */
    .color-group {
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        gap: 20px;
    }
    .color-item {
        display: inline-flex;
        align-items: center;
        gap: 6px;
    }
    .color-label {
        font-size: 13px;
        color: #606266;
        white-space: nowrap;
    }
    .color-desc {
        font-size: 12px;
        color: #999;
    }

    /* 实时预览 */
    .btn-preview {
        width: 96px;
        height: 36px;
        border-radius: 18px;
        color: #fff;
        font-weight: 700;
        font-size: 13px;
        letter-spacing: 2px;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        box-shadow: 0 4px 10px rgba(0, 0, 0, .15);
        flex-shrink: 0;
    }
    .bg-preview {
        width: 150px;
        height: 46px;
        border-radius: 8px;
        font-size: 12px;
        color: #8a5a74;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        border: 1px solid rgba(0, 0, 0, .06);
        flex-shrink: 0;
    }
    .text-preview {
        font-size: 16px;
        font-weight: 800;
        letter-spacing: 2px;
    }
    .card-preview {
        width: 84px;
        height: 112px;
        border-radius: 10px;
        display: flex;
        align-items: center;
        justify-content: center;
        position: relative;
        overflow: hidden;
        flex-shrink: 0;
        background-size: auto, 22px 22px, auto;
        box-shadow: inset 0 0 0 2px rgba(255, 255, 255, 0.5);
    }
    .card-preview-pattern {
        position: absolute;
        inset: 6px;
        border-radius: 7px;
        border: 1.5px dashed rgba(255, 95, 168, 0.5);
        background-image: radial-gradient(circle at 10px 10px, rgba(255, 95, 168, 0.2) 2px, transparent 2.5px);
        background-size: 20px 20px;
    }
    .card-preview-text {
        position: relative;
        color: #ff4d8b;
        font-weight: 800;
        letter-spacing: 3px;
        font-size: 11px;
        text-shadow: 0 1px 0 #fff;
    }
</style>
